import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {Iterable} from 'immutable';
import {createLogger} from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension'; // eslint-disable-line no-unused-vars
import ReduxThunk from 'redux-thunk';

import { createStore, applyMiddleware } from 'redux';
import reducers from './modules';
import { Provider } from 'react-redux';

// import axios from 'axios';

//Transform Immutable (with combineReducers)
const stateTransformer = (state) => {
  let  newState = {}

  for (let i of Object.keys(state)) {
    if (Iterable.isIterable(state[i])) {
      newState[i] = state[i].toJS()
    } else {
      newState[i] = state[i]
    }
  }

  return newState
}

const logger = createLogger({    // eslint-disable-line no-unused-vars
  collapsed: true,
  stateTransformer,
});

// 스토어 생성
// const store = createStore(reducers, composeWithDevTools(applyMiddleware(ReduxThunk, logger)));
const store = createStore(reducers, applyMiddleware(ReduxThunk));

// axios.defaults.withCredentials = true;


ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
